import SignIn from "../login/SignIn";

export default function Login() {
  return (
    <SignIn />
  );
}